export class NativeStreamAggregationSpanLayout {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "objective",
            "baseName": "objective",
            "type": "NativeStreamAggregationSpanLayoutObjective",
            "format": ""
        },
        {
            "name": "maxReads",
            "baseName": "maxReads",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxStorage",
            "baseName": "maxStorage",
            "type": "number",
            "format": "double"
        },
        {
            "name": "maxMemory",
            "baseName": "maxMemory",
            "type": "number",
            "format": "double"
        },
        {
            "name": "spans",
            "baseName": "spans",
            "type": "NativeStreamAggregationPinnedSpanLayout",
            "format": ""
        },
        {
            "name": "generation",
            "baseName": "generation",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationSpanLayout.attributeTypeMap;
    }
    constructor() {
    }
}
